import { cn } from "@/packages/utils";
import { BrandAsset } from "./BrandAsset";

interface BrandLockupProps {
  className?: string;
  iconClassName?: string;
  inverted?: boolean;
  textClassName?: string;
}

export function BrandLockup({
  className,
  iconClassName,
  inverted = false,
  textClassName,
}: BrandLockupProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <BrandAsset
        alt="Audinero"
        className={cn("size-8", iconClassName)}
        variant="icon"
      />
      <span
        className={cn(
          "text-[15px] font-semibold tracking-[-0.01em]",
          inverted ? "text-white" : "text-primary",
          textClassName,
        )}
      >
        Audinero
      </span>
    </div>
  );
}
